import React from 'react';
import { Heading, Button, VStack } from '@chakra-ui/react';
import { StemiInput } from '../../../components/Input';


interface DemoAskProps {
  ask: {
    key: string;
    name: string;
    type: string;
    default: any;
    value?: any;
    previousValue?: any;
  }[];
  demo: string;
  onChange: (
    code: string,
    key: string,
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.MouseEvent<HTMLElement>) => void;
  isInModal: boolean;
}

const DemoAsk: React.FC<DemoAskProps> = (props) => {
  const { ask, demo, onChange, onSubmit, isInModal } = props;

  return (
    <VStack w="full" spacing={0} gap={8} align="start">
      {!isInModal && (
        <Heading as="h3" size="xl" color="blue.500" mb={4}>
          Additional optional info for demo - {demo}
        </Heading>
      )}
      {ask.map((field, index) => (
        <StemiInput
          value={field.value}
          label={field.name}
          onChange={onChange(demo, field.key)}
        />
      ))}

      {!isInModal && (
        <Button
          type="submit"
          mt={2}
          size="lg"
          colorScheme="blue"
          onClick={(e) => onSubmit(e as any)}
        >
          Save
        </Button>
      )}
    </VStack>
  );
};

export default DemoAsk;
